import { createFileRoute, redirect } from "@tanstack/react-router";

import Home from "areas/home/pages/Home";


export const Route = createFileRoute("/_home/")({
	component: () => <Home />,
	beforeLoad: ({ context }) => {
		if (!context.auth0?.isAuthenticated) throw redirect({ to: "/auth" });
	},
	staticData: {
		footer: true
	}
});